{
  "title": "Services",
  "description": "Gérez vos services et suivez leurs performances",
  "create": "Créer un service",
  "searchPlaceholder": "Rechercher des services...",
  "columns": {
    "status": "Statut",
    "isPaid": "Payant",
    "ratings": "Évaluations",
    "name": "Nom",
    "provider": "Prestataire",
    "timeSlots": "Créneaux",
    "created": "Créé",
    "order": "Ordre",
    "question": "Question",
    "type": "Type",
    "required": "Obligatoire"
  },
  "filters": {
    "paid": "Payant",
    "notPaid": "Gratuit",
    "active": "Actif",
    "inactive": "Inactif"
  },
  "actions": {
    "activate": "Activer",
    "deactivate": "Désactiver",
    "activateSelected": "Activer la sélection",
    "deleteSelected": "Supprimer la sélection",
    "exportSelected": "Exporter la sélection",
    "exporting": "Export de {{count}} services",
    "quickActions": "Actions rapides",
    "editService": "Modifier le service",
    "activateService": "Activer le service",
    "deleteService": "Supprimer le service",
    "addUnit": "Ajouter une unité",
    "createUnit": "Créer une unité",
    "importUnits": "Importer des unités",
    "learnMore": "En savoir plus",
    "editUnit": "Modifier l'unité",
    "availability": "Disponibilité",
    "closures": "Fermetures",
    "deleteUnit": "Supprimer l'unité",
    "addQuestion": "Ajouter une question",
    "createQuestion": "Créer une question",
    "importQuestions": "Importer des questions",
    "addFirstUnit": "Ajouter la première unité",
    "addFirstQuestion": "Ajouter la première question",
    "addProvider": "Ajouter un prestataire",
    "updateUnit": "Mettre à jour l'unité",
    "addUnitAction": "Ajouter l'unité",
    "updateQuestion": "Mettre à jour la question",
    "addQuestionAction": "Ajouter la question"
  },
  "show": {
    "title": "Détails du service",
    "titleWithName": "Service {{name}}",
    "documentTitle": "{{name}} | Services",
    "loadingDescription": "Chargement des détails du service...",
    "tabs": {
      "basicInfo": "Informations de base",
      "serviceUnits": "Unités de service",
      "closures": "Fermetures",
      "serviceQuestions": "Questions de service",
      "ratingsReviews": "Notes et avis",
      "analytics": "Analytique"
    },
    "basicInfo": {
      "title": "Informations de base",
      "description": "Consultez les informations détaillées sur ce service",
      "serviceName": "Nom du service",
      "descriptionLabel": "Description",
      "noDescription": "Aucune description disponible",
      "status": "Statut",
      "serviceType": "Type de service",
      "paidService": "Service payant",
      "freeService": "Service gratuit",
      "price": "Prix"
    },
    "ratingsReviews": {
      "title": "Notes et avis",
      "description": "Consultez les notes, avis et tous les services rendus par votre entreprise et vos prestataires",
      "servicesRendered": "Services rendus"
    },
    "analytics": {
      "title": "Analytique du service",
      "description": "Aperçu complet des performances, réservations et satisfaction client de votre service"
    },
    "statusLabels": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "ratingStars": {
      "one": "1 étoile",
      "other": "{{count}} étoiles"
    }
  },
  "createPage": {
    "title": "Créer un service",
    "description": "Suivez les étapes ci-dessous pour créer un nouveau service",
    "nextCreateService": "Créer le service",
    "nextAddQuestions": "Ajouter des questions"
  },
  "editPage": {
    "title": "Modifier le service",
    "titleWithName": "Modifier le service {{name}}",
    "description": "Mettez à jour les détails de {{name}}",
    "documentTitle": "Modifier {{name}}",
    "notFoundTitle": "Service introuvable",
    "notFoundDescription": "Le service que vous essayez de modifier est introuvable."
  },
  "steps": {
    "basicInfo": {
      "title": "Informations de base",
      "createDescription": "Saisissez les informations de base de votre service",
      "editDescription": "Mettez à jour les informations de base de votre service"
    },
    "units": {
      "title": "Unités de service",
      "createDescription": "Ajoutez des unités pour suivre la disponibilité et assigner des prestataires",
      "editDescription": "Gérez les unités et assignez des prestataires"
    },
    "questions": {
      "title": "Questions de service",
      "createDescription": "Créez des questions pour les réservations clients",
      "editDescription": "Mettez à jour les questions pour les réservations clients"
    },
    "nav": {
      "nextAddUnits": "Suivant : Ajouter des unités",
      "nextAddQuestions": "Suivant : Ajouter des questions",
      "previousBasicInfo": "Précédent : Informations de base",
      "previousServiceUnits": "Précédent : Unités de service",
      "saveChanges": "Enregistrer les modifications"
    }
  },
  "form": {
    "image": "Image du service",
    "imageDescription": "Téléversez une image pour votre service",
    "uploading": "Téléversement de l'image...",
    "name": "Nom du service",
    "nameDescription": "Saisissez un nom clair et descriptif pour votre service",
    "namePlaceholder": "Saisir le nom du service",
    "description": "Description du service",
    "descriptionHint": "Décrivez en détail ce que propose votre service",
    "descriptionPlaceholder": "Décrivez votre service",
    "serviceType": "Type de service",
    "serviceTypeDescription": "Choisissez s'il s'agit d'un service gratuit ou payant",
    "free": "Gratuit",
    "paid": "Payant",
    "price": "Prix (GH₵)",
    "priceDescription": "Définissez le prix de votre service",
    "pricePlaceholder": "0,00"
  },
  "units": {
    "title": "Unités de service",
    "description": "Gérez et suivez les unités de service individuelles",
    "noProvidersTitle": "Aucun prestataire pour le moment",
    "noProvidersDescription": "Ajoutez un prestataire avant de créer des unités. Les prestataires sont assignés à chaque unité.",
    "emptyTitle": "Aucune unité de service",
    "emptyDescription": "Ajoutez votre première unité de service pour suivre la disponibilité et assigner des prestataires.",
    "emptyTableDescription": "Vous n'avez pas encore créé d'unités de service. Commencez par créer votre première unité pour suivre la disponibilité.",
    "searchPlaceholder": "Rechercher des unités...",
    "unknownProvider": "Inconnu",
    "noTimeSlots": "Aucun créneau",
    "moreSlots": "+{{count}} de plus",
    "timeSlotsCount": "{{count}} créneaux",
    "timeSlotsConfigured": "{{count}} créneaux configurés",
    "configureTimeSlots": "Configurer les créneaux",
    "unnamedUnit": "Unité sans nom",
    "defaultUnitName": "Unité",
    "dialog": {
      "addTitle": "Ajouter une unité de service",
      "editTitle": "Modifier l'unité de service",
      "addDescription": "Créez une nouvelle unité de service avec prestataire et créneaux.",
      "editDescription": "Mettez à jour les détails de l'unité de service.",
      "configureDescription": "Configurez les détails de l'unité et le planning de disponibilité.",
      "unitName": "Nom de l'unité",
      "unitNameDescription": "Saisissez un nom descriptif pour cette unité de service",
      "unitNameDescriptionShort": "Saisissez un nom pour cette unité de service",
      "unitNamePlaceholder": "Saisir le nom de l'unité",
      "provider": "Prestataire",
      "providerDescription": "Sélectionnez le prestataire qui gérera cette unité",
      "providerDescriptionShort": "Sélectionnez qui fournira ce service",
      "providerPlaceholder": "Sélectionner un prestataire",
      "noProvidersAvailable": "Aucun prestataire disponible — ajoutez-en un dans Prestataires",
      "timeSlots": "Créneaux horaires",
      "timeSlotsDescription": "Configurez quand cette unité est disponible pour les réservations",
      "timeSlotsDescriptionShort": "Configurez la disponibilité de cette unité",
      "creating": "Création...",
      "updating": "Mise à jour..."
    }
  },
  "questions": {
    "title": "Questions de service",
    "description": "Gérez les questions pour les réservations de service",
    "emptyTitle": "Aucune question",
    "emptyDescription": "Ajoutez des questions pour recueillir des informations auprès des clients lors de la réservation.",
    "emptyTableTitle": "Aucune question de service",
    "emptyTableDescription": "Vous n'avez pas encore créé de questions de service. Commencez par créer votre première question pour recueillir des informations lors de la réservation.",
    "searchPlaceholder": "Rechercher des questions...",
    "optionsCount": "{{count}} options",
    "optional": "Facultatif",
    "requiredBadge": "Obligatoire",
    "dialog": {
      "addTitle": "Ajouter une question",
      "editTitle": "Modifier la question",
      "description": "Configurez les détails et le type de la question.",
      "questionText": "Texte de la question",
      "questionTextDescription": "Saisissez la question que vous souhaitez poser aux clients",
      "questionTextPlaceholder": "Saisissez votre question",
      "questionType": "Type de question",
      "questionTypeDescription": "Choisissez comment les clients répondront à cette question",
      "answerOptions": "Options de réponse",
      "answerOptionsDescription": "Ajoutez les options disponibles pour cette question",
      "optionPlaceholder": "Option {{number}}",
      "addOption": "Ajouter une option",
      "requiredQuestion": "Question obligatoire",
      "requiredQuestionDescription": "Rendez cette question obligatoire pour les clients"
    },
    "types": {
      "text": "Texte court",
      "textarea": "Texte long",
      "select": "Liste déroulante",
      "radio": "Choix multiple",
      "checkbox": "Cases à cocher",
      "date": "Date",
      "time": "Heure"
    }
  },
  "closures": {
    "add": "Ajouter",
    "title": "Fermetures et jours spéciaux",
    "description": "Gérez les dates de fermeture et les jours avec des horaires personnalisés. Ils s'appliquent à toutes les unités sauf si une unité a sa propre fermeture.",
    "blockedDays": {
      "title": "Jours bloqués (fermé)",
      "description": "Dates où ce service est entièrement fermé pour toutes les unités.",
      "emptyTitle": "Aucun jour bloqué",
      "emptyDescription": "Ajoutez des dates où ce service sera fermé pour les clients.",
      "add": "Ajouter un jour bloqué",
      "dialogTitle": "Ajouter un jour bloqué",
      "dialogDescription": "Les clients ne pourront pas réserver ce service à la date sélectionnée.",
      "reasonOptional": "Motif (facultatif)",
      "reasonPlaceholder": "Jour férié",
      "removeAriaLabel": "Supprimer le jour bloqué"
    },
    "specialDays": {
      "title": "Jours spéciaux (horaires personnalisés)",
      "description": "Dates avec des horaires d'ouverture différents de l'habitude.",
      "emptyTitle": "Aucun jour spécial",
      "emptyDescription": "Ajoutez des dates avec des horaires personnalisés, comme une fermeture anticipée ou des heures prolongées.",
      "add": "Ajouter un jour spécial",
      "dialogTitle": "Ajouter un jour spécial",
      "dialogDescription": "Définissez des horaires personnalisés pour une date sur toutes les unités.",
      "opens": "Ouverture",
      "closes": "Fermeture",
      "reasonPlaceholder": "Fermeture anticipée",
      "removeAriaLabel": "Supprimer le jour spécial"
    },
    "unitDialog": {
      "title": "Fermetures prestataire — {{name}}",
      "description": "Bloquez des dates spécifiques pour cette unité de service et ce prestataire uniquement.",
      "reasonPlaceholder": "Jour de congé du prestataire",
      "loading": "Chargement...",
      "noBlockedDays": "Aucun jour bloqué"
    },
    "fields": {
      "date": "Date"
    }
  },
  "scheduler": {
    "title": "Configurer les créneaux horaires",
    "description": "Ces créneaux s'appliquent uniquement à ce prestataire. Les autres prestataires du même service sont indépendants — nous ne supposons pas de salle ou fauteuil partagé. Utilisez n'importe quelle heure de début et de fin (par exemple 12:00–12:15).",
    "empty": "Aucun créneau pour le moment. Ajoutez les horaires auxquels les clients peuvent réserver avec ce prestataire.",
    "addSlot": "Ajouter un créneau",
    "done": "Terminé",
    "editSlot": "Modifier le créneau",
    "addSlotTitle": "Ajouter un créneau",
    "slotDescription": "Définissez le jour et les horaires exacts de cette plage réservable.",
    "day": "Jour",
    "startTime": "Heure de début",
    "endTime": "Heure de fin",
    "overlapHint": "Seuls les créneaux de cette unité sont vérifiés pour les chevauchements. Les autres prestataires du même service peuvent utiliser les mêmes horaires.",
    "removeSlot": "Supprimer le créneau",
    "saveSlot": "Enregistrer le créneau",
    "editSlotSr": "Modifier le créneau",
    "removeSlotSr": "Supprimer le créneau",
    "days": {
      "monday": "Lundi",
      "tuesday": "Mardi",
      "wednesday": "Mercredi",
      "thursday": "Jeudi",
      "friday": "Vendredi",
      "saturday": "Samedi",
      "sunday": "Dimanche"
    }
  },
  "analytics": {
    "kpi": {
      "totalBookings": "Total des réservations",
      "totalBookingsDescription": "Réservations depuis le début",
      "totalRevenue": "Revenu total",
      "totalRevenueDescription": "Gains totaux",
      "averageRating": "Note moyenne",
      "averageRatingDescription": "Satisfaction client",
      "fulfillmentRate": "Taux de réalisation",
      "fulfillmentRateDescription": "Taux d'achèvement des services",
      "changeFromLastPeriod": "{{change}} % par rapport à la période précédente"
    },
    "charts": {
      "noData": "Aucune donnée",
      "noDataProvider": "Aucune donnée",
      "bookingsTimeline": {
        "title": "Chronologie des réservations",
        "description": "Réservations terminées et annulées des 6 derniers mois",
        "trendUp": "En hausse de {{change}} % ce mois-ci",
        "trendDown": "En baisse de {{change}} % ce mois-ci"
      },
      "appointmentStatus": {
        "title": "Statut des rendez-vous",
        "description": "Répartition des statuts de rendez-vous",
        "totalAppointments": "Total des rendez-vous : {{count}}"
      },
      "revenue": {
        "title": "Revenus",
        "description": "Revenus au fil du temps"
      },
      "providerPerformance": {
        "title": "Performance des prestataires",
        "description": "Revenus et réservations par prestataire",
        "totalRevenueFooter": "Revenu total : GH₵{{amount}}"
      },
      "ratingsDistribution": {
        "title": "Répartition des notes",
        "description": "Répartition des notes clients",
        "basedOnReviews": "Basé sur {{count}} avis au total"
      },
      "peakHours": {
        "title": "Heures de pointe",
        "description": "Heures de réservation les plus chargées",
        "peakTime": "Heure de pointe : {{hour}}"
      },
      "providerBookings": {
        "title": "Réservations par prestataire",
        "description": "Réservations par prestataire",
        "topPerformer": "Meilleur prestataire : {{name}} avec {{count}} réservations"
      },
      "providerUtilization": {
        "title": "Utilisation des prestataires",
        "description": "Utilisation de la capacité des prestataires",
        "footer": "Utilisation moyenne : {{avg}} % | Plus élevée : {{name}} ({{value}} %)"
      },
      "providerRatings": {
        "title": "Notes des prestataires",
        "description": "Notes moyennes par prestataire",
        "footer": "Note moyenne : {{avg}}/5 | Meilleure note : {{name}} ({{rating}}/5)"
      },
      "totalRatings": {
        "title": "Total des notes",
        "description": "Toutes les soumissions de notes",
        "descriptionOverTime": "Notes reçues au fil du temps"
      },
      "fulfillmentRate": {
        "title": "Taux de réalisation",
        "description": "Terminés vs total des réservations",
        "descriptionOverTime": "Taux d'achèvement des services au fil du temps"
      },
      "labels": {
        "completed": "Terminé",
        "cancelled": "Annulé",
        "pending": "En attente",
        "rescheduled": "Reporté",
        "revenue": "Revenus",
        "bookings": "Réservations",
        "rating": "Note",
        "utilization": "Utilisation",
        "reviews": "Avis",
        "fulfillmentRate": "Taux de réalisation"
      }
    }
  },
  "reviews": {
    "averageRating": "Note moyenne",
    "outOfFive": "sur 5,0",
    "totalReviews": "Total des avis",
    "customerReviews": "Avis clients",
    "totalRatings": "Total des notes",
    "individualSubmissions": "Soumissions de notes individuelles"
  },
  "rendered": {
    "searchPlaceholder": "Rechercher des services rendus...",
    "emptyTitle": "Aucun service rendu",
    "emptyDescription": "Les services rendus par votre entreprise et vos prestataires apparaîtront ici.",
    "filters": {
      "all": "Tous",
      "completed": "Terminé",
      "pending": "En attente",
      "cancelled": "Annulé"
    },
    "columns": {
      "customer": "Client",
      "service": "Service",
      "provider": "Prestataire",
      "date": "Date",
      "time": "Heure",
      "status": "Statut",
      "rating": "Note"
    }
  },
  "validation": {
    "nameRequired": "Le nom du service est requis",
    "descriptionRequired": "La description du service est requise",
    "imageRequired": "L'image du service est requise",
    "priceRequired": "Le prix doit être supérieur à 0 pour les services payants",
    "imageUploadIncomplete": "Le téléversement de l'image a échoué ou est incomplet. Veuillez téléverser à nouveau l'image.",
    "unitNameRequired": "Saisissez un nom pour cette unité de service.",
    "providerRequired": "Sélectionnez un prestataire pour cette unité.",
    "serviceLoadFailed": "Ce service n'a pas pu être chargé. Actualisez la page et réessayez.",
    "businessLoadFailed": "Votre entreprise n'a pas pu être chargée. Actualisez la page et réessayez.",
    "atLeastOneUnit": "Ajoutez au moins une unité de service avant de continuer.",
    "unitTimeslotsRequired": "Ajoutez des créneaux pour « {{name}} ».",
    "slotOverlap": "Deux créneaux le {{day}} se chevauchent ({{startA}}–{{endA}} et {{startB}}–{{endB}}). Ajustez les horaires pour ce prestataire.",
    "singleSlotOverlap": "Ce créneau chevauche {{start}}–{{end}} le {{day}}. Choisissez un autre horaire pour ce prestataire.",
    "invalidTimes": "Saisissez une heure de début et de fin valides (HH:MM).",
    "endBeforeStart": "L'heure de fin doit être après l'heure de début.",
    "overlapsFound": "Deux créneaux ou plus le même jour se chevauchent. Modifiez les horaires pour éviter un double planning.",
    "unitNotFound": "Cette unité de service est introuvable. Actualisez la page et réessayez.",
    "providerNotFound": "Le prestataire sélectionné est introuvable. Choisissez un autre prestataire.",
    "notAProvider": "L'utilisateur sélectionné n'est pas un prestataire. Choisissez quelqu'un de votre liste de prestataires.",
    "businessNotFound": "Votre profil entreprise est introuvable. Actualisez et réessayez.",
    "serviceNotFound": "Ce service est introuvable. Actualisez la page et réessayez.",
    "serviceNotInBusiness": "Ce service n'appartient pas à votre entreprise.",
    "questionTextRequired": "Veuillez saisir le texte de la question",
    "questionOptionsRequired": "Veuillez ajouter au moins une option"
  },
  "toasts": {
    "uploadFailed": "Échec du téléversement de l'image",
    "imageRequired": "L'image du service est requise",
    "imageTooLarge": "L'image téléversée est trop volumineuse. Essayez un fichier plus petit (moins de 5 Mo).",
    "created": "Service créé avec succès !",
    "createdFull": "Service créé avec succès avec tous les détails !",
    "createFailed": "Échec de la création du service",
    "createUnitsFailed": "Échec de la création des unités de service",
    "updated": "Service mis à jour avec succès !",
    "updateFailed": "Échec de la mise à jour du service",
    "businessUnknown": "Impossible de déterminer l'entreprise pour ce service",
    "questionsSaveFailed": "Impossible d'enregistrer les questions du service. Réessayez.",
    "unitAvailabilityUpdated": "Disponibilité de l'unité mise à jour avec succès",
    "timeslotsSaveFailed": "Impossible d'enregistrer les créneaux. Réessayez.",
    "unitUpdated": "Unité de service mise à jour avec succès",
    "unitCreated": "Unité de service créée avec succès",
    "unitUpdateFailed": "Impossible de mettre à jour cette unité de service. Réessayez.",
    "unitCreateFailed": "Impossible de créer cette unité de service. Réessayez.",
    "unitDeleted": "Unité supprimée avec succès",
    "unitDeleteFailed": "Impossible de supprimer cette unité de service.",
    "questionUpdated": "Question mise à jour avec succès",
    "questionAdded": "Question ajoutée avec succès",
    "questionDeleted": "Question supprimée avec succès",
    "blockedDayAdded": "Jour bloqué ajouté",
    "blockedDayAddFailed": "Échec de l'ajout du jour bloqué",
    "specialDayAdded": "Jour spécial ajouté",
    "specialDayAddFailed": "Échec de l'ajout du jour spécial",
    "blockedDayRemoved": "Jour bloqué supprimé",
    "blockedDayRemoveFailed": "Échec de la suppression du jour bloqué",
    "specialDayRemoved": "Jour spécial supprimé",
    "specialDayRemoveFailed": "Échec de la suppression du jour spécial",
    "providerBlockedDayAdded": "Jour bloqué du prestataire ajouté"
  },
  "dialogs": {
    "activateTitle": "Activate Service",
    "activateTitleBulk": "Activate {{count}} Services",
    "activateDescription": "Are you sure you want to activate \"{{name}}\"? It will become visible to customers.",
    "activateDescriptionBulk": "Are you sure you want to activate {{count}} services? They will become visible to customers.",
    "activateConfirm": "Activate",
    "activated": "Service activated successfully",
    "activatedBulk": "{{count}} services activated successfully",
    "activateError": "Failed to activate service",
    "deactivateTitle": "Deactivate Service",
    "deactivateTitleBulk": "Deactivate {{count}} Services",
    "deactivateDescription": "Are you sure you want to deactivate \"{{name}}\"? It will no longer be visible to customers.",
    "deactivateDescriptionBulk": "Are you sure you want to deactivate {{count}} services? They will no longer be visible to customers.",
    "deactivateConfirm": "Deactivate",
    "deactivated": "Service deactivated successfully",
    "deactivatedBulk": "{{count}} services deactivated successfully",
    "deactivateError": "Failed to deactivate service",
    "deleteTitle": "Delete Service",
    "deleteTitleBulk": "Delete {{count}} Services",
    "deleteDescription": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
    "deleteDescriptionBulk": "Are you sure you want to delete {{count}} services? This action cannot be undone.",
    "deleted": "Service deleted successfully",
    "deletedBulk": "{{count}} services deleted successfully",
    "deleteError": "Failed to delete service",
    "passwordRequired": "Password is required",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter your password to confirm"
  }
}
